import {Translator} from '@logistics-frontend/core/i18n'

import {Category, SummableRequirement} from '../../types'

/*// NOTE: Костыль TXI-8880
const shouldHideCargoRequirements = ({category_name}: Category) => category_name === 'cargo'

const filterCargoRequirements = (requirements: SummableRequirement[]) =>
  requirements.filter(
    ({type}) => !['cargo', 'cargo_loaders', 'cargo_loaders.two_loaders', 'cargo_loaders.one_loader'].includes(type),
  )*/

export const getRequirements = (tariff: Category) => {
  const requirements = tariff.summable_requirements || []
  return requirements
}

export const hasMultiplier = (requirement: SummableRequirement) => 'multiplier' in requirement

export const mapRequirementsToListItems = (requirements: SummableRequirement[], unit: string) =>
  requirements.map(({type_translate: label, max_price: value}) => ({
    value,
    label,
    unit,
  }))

export const mapSpecialRequirementsToListItems = (requirements: SummableRequirement[], t: Translator) =>
  requirements.map(({type_translate: label, multiplier}) => ({
    value: t('tariffs.units.multiplier', {
      placeholder: {multiplier},
    }),
    label,
  }))
